import {
  Dropdown,
  PaginatedDropdownList,
  UsersAllListData,
  usersListListInfiniteOptions
} from '@crm/api'
import { InfiniteSelect, RangePickerFilter } from '@crm/components'
import { defaultFiltersMultipleValues } from '@crm/utils'
import { useQueryParams, useQueryUpdate } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { DEFAULT_ISO_DATE_FORMAT } from '@shared/utils'

import { Button, Flex, Space } from 'antd'
import dayjs from 'dayjs'
import { useState } from 'react'

const PERIODS_DAYS = [7, 14, 30]

export const Filters = () => {
  const [isPeriodFilter, setIsPeriodFilter] = useState(true)

  const { t } = useLocales()
  const params = useQueryParams()
  const { updateQuery } = useQueryUpdate()

  const userValue = defaultFiltersMultipleValues(params?.user)

  const currentRangeDays =
    params?.date_from && params?.date_to
      ? dayjs(params.date_to).diff(dayjs(params.date_from), 'day')
      : undefined

  const applyPeriod = (days: number) => {
    const from = dayjs().subtract(days, 'day').format(DEFAULT_ISO_DATE_FORMAT)
    const to = dayjs().format(DEFAULT_ISO_DATE_FORMAT)

    setIsPeriodFilter(false)
    updateQuery({
      date_from: from,
      date_to: to
    })
  }

  const onResetPeriod = () => {
    setIsPeriodFilter(true)
    updateQuery({
      date_from: undefined,
      date_to: undefined
    })
  }

  return (
    <Flex wrap gap={8}>
      {isPeriodFilter && (
        <RangePickerFilter
          placeholder={[t('filter.date_from'), t('filter.date_to')]}
        />
      )}

      <Space.Compact>
        <Button
          type={isPeriodFilter ? 'primary' : 'default'}
          onClick={onResetPeriod}
        >
          {t('filter.period')}
        </Button>

        {PERIODS_DAYS.map((days) => (
          <Button
            key={days}
            type={
              currentRangeDays === days && !isPeriodFilter
                ? 'primary'
                : 'default'
            }
            onClick={() => applyPeriod(days)}
          >
            {days === 30
              ? t('nomenclature.one_month')
              : `${days} ${t('nomenclature.days')}`}
          </Button>
        ))}
      </Space.Compact>

      <InfiniteSelect<UsersAllListData, PaginatedDropdownList, Dropdown>
        value={userValue}
        className="select-min-width"
        popupMatchSelectWidth
        placeholder={t('opportunities.responsible')}
        getQueryFunction={usersListListInfiniteOptions}
        onChange={(user) => updateQuery({ user })}
        baseOptions={{
          query: { preference: params?.user }
        }}
      />
    </Flex>
  )
}
